import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { ItemsToSetUpListSubjectService } from '@app/modules/vault/components/add-document/items-to-set-up/items-to-set-up.subject';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'itemSetupName',
})
export class ItemSetupName implements PipeTransform {
  capitalizeFirstWord = ['std', 'ltd', 'atv', 'rv', 'ltc'];
  constructor() {}
  transform(item: any, jsonData: any = [], linkedTemplateData: any = [], current_template: any = null): string | Observable<string> {
    let type = item.type?.toLowerCase();
    if (type == 'general') {
      return 'Complete general information';
    } else if (type == 'description') {
      return 'Add a description';
    } else if (type == 'share') {
      return 'Manage share settings';
    } else if (type == 'reminder') {
      return 'Manage Checklist';
    } else if (type == 'attach') {
      return item.sub_type;
    } else if (type == 'note') {
      return item.sub_type ? `Add Note: ${item.sub_type}` : 'Add additional notes';
    } else if (type == 'location') {
      if (item.sub_type == 'Physical') {
        // let countText = this.locationSuggestionList(current_template);
        return 'Physical location'; // + countText;
      } else if (item.sub_type == 'Password') {
        //let countText = this.locationSuggestionList(current_template);
        return 'Password location'; // + countText;
      }
    } else if (type == 'api') {
      if (item.sub_type == 'VehicleDatabase' || item.sub_type == 'Zillow') {
        return 'Connect to a live data feed';
      } else if (item.sub_type == 'MX') {
        return 'Connect to MX (Financial Data Aggregator)';
      }
    } else if (type == 'template_linking') {
      if (linkedTemplateData.findIndex((x) => x.type == item.sub_type) >= 0) {
        let link_text = linkedTemplateData.find((x) => x.type == item.sub_type).label.toLowerCase();

        link_text = link_text.charAt(0).toUpperCase() + link_text.slice(1);
        try {
          let count = current_template[item.sub_type].split(',').length;
          if (count > 0) {
            link_text = link_text + ' (' + count + ')';
          }
        } catch (error) {}
        return link_text;
      } else {
        return item.sub_type;
      }
    } else if (type == 'role_players') {
      const rolePlayerData = jsonData.find((data) => {
        return data.role_player_category === item.sub_type;
      });
      if (rolePlayerData != null && rolePlayerData != undefined) {
        return rolePlayerData.role_player_name.charAt(0).toUpperCase() + rolePlayerData.role_player_name.slice(1);
      } else {
        return item.sub_type.charAt(0).toUpperCase() + item.sub_type.slice(1);
      }
    } else if (type == 'financial_attributes' || type == 'financial_atributes' || type == 'insurance_attributes') {
      let returnString = `${this.findVaultForm(item?.sub_type?.toLowerCase(), jsonData)}`.toLowerCase() ?? 'Financial Attributes';
      const name = returnString.charAt(0).toUpperCase() + returnString.slice(1);
      const canCapitalizeAllFirst = this.capitalizeString(name, this.capitalizeFirstWord);
      return canCapitalizeAllFirst;
    } else {
      return type;
    }
  }

  locationSuggestionList(current_template) {
    let count_list =
      current_template?.recommended_locations.length > 1 ? current_template?.recommended_locations : current_template.recommended_password_locations;
    if (count_list.length > 1) {
      let count = count_list.split(',').length;
      return count > 1 ? ` (${count})` : '';
    } else {
      return '';
    }
  }
  findVaultForm(param: string, jsonData): any {
    const json = jsonData;
    if (json) {
      for (let key in json) {
        if (typeof json[key] === 'object') {
          if (json[key]?.vault_form_code?.toLowerCase() === param) {
            return key;
          }
        }
      }
    }
    return param ?? null;
  }
  capitalizeString(str, specificWords?: Array<string>) {
    return str
      .split(/\s+/)
      .map((word) => (specificWords.includes(word.toLowerCase()) ? word.toUpperCase() : word[0].toUpperCase() + word.slice(1).toLowerCase()))
      .join(' ');
  }
}
